"use client"

import React, { Component, createContext } from "react";
import { getHostUrl } from "../utils/UrlManager";

export const ThemeContext = createContext(null);

class ThemeContextProvider extends Component {

    componentDidMount() {
        this.preloadMenu();
    }

    constructor(props) {
        super(props);
        this.state = {
            menuItems: []
        }
    }

    preloadMenu() {
        let that = this;
        const hostUrl = getHostUrl();
        let url = hostUrl + 'barber/account/menu';
        fetch(url, {
            method: 'GET',
            headers: new Headers({
                'AccountMenu' :  'menu',
                'Content-Type' : 'application/json'
            })
        }).then(response => {
            return response.json();
        })
            .then(data => {
                if (typeof data !== "undefined" && data.success === true) {
                    this.setState({
                        menuItems: data.data.data.menu.items
                    });
                }
            })
            .catch(error => {
               console.log(error);
            });
    }

    render() {
        return (
            <ThemeContext.Provider value={ {
                ...this.state
            } }
           >
                { this.props.children }
            </ThemeContext.Provider>
        );
    }
}

export default ThemeContextProvider;
